import { render, staticRenderFns } from "./LeccionD5.vue?vue&type=template&id=26417db1&"
import script from "./LeccionD5.vue?vue&type=script&lang=js&"
export * from "./LeccionD5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports